<div class="content-holder">
    <div class="header align-items-center">
      <div class="subtitle" *transloco="let t; scope: 'profile'">
        {{ t('profile.specialisms_help') }}
      </div>
    </div>

    <div class="row body">
      <div class="col-12">
        @let errorVariable = error();
        @if (errorVariable) {
          <alert [type]="'danger'" [dismissible]="true" class="mb-4">
            <span>{{ errorVariable | transloco }}</span>
          </alert>
        }

          <section class="specialisms-section mt-3">
            <div class="section-heading" *transloco="let t; scope: 'profile'">
              <h2 class="flex-grow-1">{{ t('profile.my_specialisms') }}</h2>

                <div class="spinner-border text-primary heading-loader" role="status" [style.opacity]="isAnythingLoading() ? 1 : 0" [style.transition]="'opacity 0.3s ease-in-out'">
                  <span class="visually-hidden">Loading...</span>
                </div>

              <span class="section-meta">{{ selectedCount() }}/{{ SPECIALISMS_MAX_SELECTED }}</span>
            </div>

            @if (selectedTopics().length) {
              <div class="specialisms-grid">
                @for (topic of selectedTopics(); track topic.id) {
                  <multisite-icon-pill
                    [icon]="topic.icon"
                    [labelText]="topic.name"
                    [selectable]="true"
                    [inverted]="true"
                    class="selectable-item"
                    [removable]="true"
                    [disabled]="isPending(topic.id)"
                    (click)="removeTopic(topic)"
                  ></multisite-icon-pill>
                }
              </div>
            } @else {
              <div class="specialisms-empty text-muted" *transloco="let t">
                {{ t('common.none_yet') }}
              </div>
            }
          </section>

          <section class="specialisms-section mt-4">
            <div class="section-heading">
              <h2 class="flex-grow-1" *transloco="let t; scope: 'profile'">{{ t('profile.specialisms_available') }}</h2>
               <div class="spinner-border text-primary heading-loader" role="status" [style.opacity]="isAnythingLoading() ? 1 : 0" [style.transition]="'opacity 0.3s ease-in-out'">
                  <span class="visually-hidden">Loading...</span>
                </div>
              <span class="section-meta" *transloco="let t">{{ t('common.remaining') }} <span class="ms-2">{{ remainingSlots() }}</span></span>
            </div>

            @if (availableTopics().length) {
              <div class="specialisms-grid">
                @for (topic of availableTopics(); track topic.id) {
                  <multisite-icon-pill
                    [icon]="topic.icon"
                    [labelText]="topic.name"
                    [selectable]="true"
                    class="selectable-item"
                    [disabled]="isPending(topic.id) || selectedCount() >= SPECIALISMS_MAX_SELECTED"
                    (click)="addTopic(topic)"
                  ></multisite-icon-pill>
                }
              </div>
            } @else {
              <div class="specialisms-empty text-muted" *transloco="let t">
                {{ t('common.none') }}
              </div>
            }
          </section>
      </div>
    </div>
</div>
